<h4 mat-dialog-title *ngIf="action === 0">{{ 'dataManagement.tags.tagsManagement.dialog.newTag' | transloco }}</h4>
<h4 mat-dialog-title *ngIf="action === 1">{{ 'dataManagement.tags.tagsManagement.dialog.editTag' | transloco }}</h4>

<div mat-dialog-content>
  <form [formGroup]="form">
    <div>
      {{ 'dataManagement.tags.tagsManagement.dialog.selectColor' | transloco }}
      <button class="color-button" mat-raised-button (click)="isPickerOpen = !isPickerOpen" type="button"
      cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        {{ (isPickerOpen ? 'common.buttons.close' : 'common.buttons.open') | transloco }}
      </button>
      {{ 'dataManagement.tags.tagsManagement.dialog.defineCustomColor' | transloco }}
      <mat-form-field class="palette-form-field"><input matInput type="color" formControlName="color"
          class="palette-input"></mat-form-field>
    </div>
    <!-- Preview: -->
    <div class="preview-container">
      <mat-card class="single-tag-container">
        <mat-card-content>
          <mat-form-field appearance="outline" class="tag-form-field">
            <mat-label>{{ 'dataManagement.tags.tagsManagement.dialog.tagName' | transloco }}</mat-label>
            <mat-chip [ngStyle]="{'background-color': form.controls.color.value}">
              <div class="single-tag">
                <input autocomplete="off" matInput formControlName="name" (keydown.backspace)="$event.stopImmediatePropagation()">
              </div>
            </mat-chip>
            <mat-error *ngIf="form.controls.name.errors && form.controls.name.hasError('required')">
              {{ 'dataManagement.tags.tagsManagement.dialog.nameRequired' | transloco }}
            </mat-error>
            <mat-error *ngIf="form.controls.name.errors && form.controls.name.hasError('maxlength')">
              {{ 'dataManagement.tags.tagsManagement.dialog.tooLong' | transloco }}
            </mat-error>
            <mat-error *ngIf="form.controls.name.errors && form.controls.name.errors?.['forbiddenName']">
              {{ 'dataManagement.tags.tagsManagement.dialog.nameAlreadyExists' | transloco }}
            </mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <mat-card class="description-container">
        <mat-card-content>
          <mat-form-field appearance="outline" class="tag-form">
            <mat-label>{{ 'dataManagement.tags.tagsManagement.dialog.tagDescription' | transloco }}</mat-label>
            <input matInput formControlName="description">
            <mat-error *ngIf="form.controls.description.errors && form.controls.description.hasError('maxlength')">
              {{ 'dataManagement.tags.tagsManagement.dialog.tooLong' | transloco }}
            </mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button *ngIf="action === 0" (click)="doAction()" mat-raised-button type="submit" color="primary">
    {{ 'dataManagement.tags.tagsManagement.dialog.newTag' | transloco }}</button>
  <button *ngIf="action === 1" (click)="doAction()" mat-raised-button type="submit" color="primary">
    {{ 'common.buttons.save' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isPickerOpen"
  [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="isPickerOpen = false">
  <mat-action-list class="example-list colors-list">
    <button mat-list-item *ngFor="let color of allDefaultColors" (click)="selectDefaultColor(color)"
      [ngStyle]="{'background-color': color, 'width': '50px', 'height': '50px', 'margin': '2px'}">
    </button>
  </mat-action-list>
</ng-template>
